import React, {Component} from 'react'
import '../../styles/HomePageStyles/tokencountdown.css'

export default class TokenCountdown extends Component{
    constructor(props){
        super(props)
        this.state={
            daysLeft: 0,
            hoursLeft: 0,
            minutesLeft: 0,
            secondsLeft:0,
        }
    }
    componentDidMount() {

        this.interval = setInterval(() => this.setState({
            daysLeft: Math.floor((new Date("Nov 21, 2018 00:00:00").getTime()-new Date().getTime())/(1000 * 60 * 60 * 24)),
            hoursLeft: Math.floor(((new Date("Nov 21, 2018 00:00:00").getTime()-new Date().getTime()) % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
            minutesLeft: Math.floor(((new Date("Nov 21, 2018 00:00:00").getTime()-new Date().getTime()) % (1000 * 60 * 60)) / (1000 * 60)),
            secondsLeft: Math.floor(((new Date("Nov 21, 2018 00:00:00").getTime()-new Date().getTime()) % (1000 * 60)) / 1000),
        }), 1000);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render(){
        return(
            <div className="tc__container">
                <div className="tc__title">Public sale starts in:</div>

                <div style={{marginBottom: '25px'}} />

                <div className="tc__timer-container">
                    <div className="tc__timer-box">
                        <div className="tc__timer-number">{this.state.daysLeft}</div>
                        <div className="tc__timer-unit">days</div>
                    </div>
                    <div className="tc__timer-box">
                        <div className="tc__timer-number">{this.state.hoursLeft}</div>
                        <div className="tc__timer-unit">hours</div>
                    </div>
                    <div className="tc__timer-box">
                        <div className="tc__timer-number">{this.state.minutesLeft}</div>
                        <div className="tc__timer-unit">minutes</div>
                    </div>
                    <div className="tc__timer-box">
                        <div className="tc__timer-number">{this.state.secondsLeft}</div>
                        <div className="tc__timer-unit">seconds</div>
                    </div>
                </div>

                <div style={{marginBottom: '25px'}} />

                <div className="tc__end-title">Private sale ended on 15th Oct 2018</div>

                <div style={{marginBottom: '25px'}} />

                <div className="tc__progress-bar-container">
                    <div className="tc__progress-bar-bar"/>
                </div>

                <div style={{marginBottom: '25px'}} />


                <div className="tc__progress-bar-information-container">
                    Soft cap:<div className="tc__progress-bar-information">40 000 ETH</div>
                </div>

                <div className="tc__progress-bar-information-container">
                    Min. transaction amount:<div className="tc__progress-bar-information">30 ETH</div>
                </div>

                <div className="tc__progress-bar-information-container">
                    Target:<div className="tc__progress-bar-information">144 700 ETH</div>
                </div>

                <div style={{marginBottom: '20px'}} />

                <div className="tc__join-button">
                    Join token sale
                </div>


            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/HomePage/TokenCountdown.js